/* Sami IT Services - Animation & Interaction Scripts */
(function() {
  'use strict';

  // === PAGE LOAD BAR ===
  function initLoadBar() {
    const bar = document.createElement('div');
    bar.className = 'sami-page-bar';
    document.body.prepend(bar);
    setTimeout(() => bar.remove(), 2000);
  }

  // === SCROLL-TRIGGERED ANIMATIONS (Intersection Observer) ===
  function initScrollAnimations() {
    const els = document.querySelectorAll('.sa-fade-up, .sa-fade-left, .sa-fade-right');
    if (!els.length) return;
    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry, i) => {
        if (entry.isIntersecting) {
          setTimeout(() => {
            entry.target.classList.add('sa-visible');
          }, (entry.target.dataset.delay || 0) * 1000);
          observer.unobserve(entry.target);
        }
      });
    }, { threshold: 0.12, rootMargin: '0px 0px -50px 0px' });
    els.forEach(el => observer.observe(el));
  }

  // === COUNTER ANIMATION ===
  function animateCounter(el) {
    const target = parseInt(el.dataset.target || el.textContent, 10);
    if (isNaN(target)) return;
    const duration = 2000;
    const step = 16;
    const increment = target / (duration / step);
    let current = 0;
    el.textContent = '0';
    const timer = setInterval(() => {
      current += increment;
      if (current >= target) {
        current = target;
        clearInterval(timer);
      }
      el.textContent = Math.floor(current) + (el.dataset.suffix || '');
    }, step);
  }

  function initCounters() {
    const counters = document.querySelectorAll('.sami-counter');
    if (!counters.length) return;
    const observer = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          animateCounter(entry.target);
          observer.unobserve(entry.target);
        }
      });
    }, { threshold: 0.5 });
    counters.forEach(c => observer.observe(c));
  }

  // === SCROLL TO TOP BUTTON ===
  function initScrollTop() {
    const btn = document.createElement('button');
    btn.className = 'sami-totop';
    btn.setAttribute('aria-label', 'Scroll to top');
    btn.innerHTML = '&#8679;';
    document.body.appendChild(btn);
    window.addEventListener('scroll', () => {
      btn.classList.toggle('show', window.scrollY > 400);
    }, { passive: true });
    btn.addEventListener('click', () => {
      window.scrollTo({ top: 0, behavior: 'smooth' });
    });
  }

  // === FAQ ACCORDION ===
  function initFAQ() {
    document.querySelectorAll('.sami-faq-item').forEach(item => {
      const q = item.querySelector('.sami-faq-question');
      if (!q) return;
      q.addEventListener('click', () => {
        const isOpen = item.classList.contains('open');
        document.querySelectorAll('.sami-faq-item.open').forEach(i => i.classList.remove('open'));
        if (!isOpen) item.classList.add('open');
      });
    });
  }

  // === STAGGER DELAYS FOR GRID ITEMS ===
  function initStagger() {
    document.querySelectorAll('.sami-svc-grid .sa-fade-up, .sami-reviews-grid .sa-fade-up').forEach((el, i) => {
      el.style.transitionDelay = (i * 0.12) + 's';
    });
  }

  // === SMOOTH ANCHOR SCROLLING ===
  function initSmoothScroll() {
    document.querySelectorAll('a[href^="#"]').forEach(a => {
      a.addEventListener('click', (e) => {
        const id = a.getAttribute('href').slice(1);
        const target = document.getElementById(id);
        if (target) {
          e.preventDefault();
          target.scrollIntoView({ behavior: 'smooth', block: 'start' });
        }
      });
    });
  }

  // === HEADER SCROLL EFFECT ===
  function initHeaderScroll() {
    const header = document.querySelector('header, .header');
    if (!header) return;
    window.addEventListener('scroll', () => {
      if (window.scrollY > 80) {
        header.style.boxShadow = '0 4px 20px rgba(0,0,0,0.15)';
      } else {
        header.style.boxShadow = '';
      }
    }, { passive: true });
  }

  // === INIT ALL ===
  document.addEventListener('DOMContentLoaded', () => {
    initLoadBar();
    initScrollAnimations();
    initCounters();
    initScrollTop();
    initFAQ();
    initStagger();
    initSmoothScroll();
    initHeaderScroll();
  });

})();
